import { Component, Inject } from '@angular/core';
import { StateService } from "@uirouter/angular";
import { ActivityTypeDataService } from "../../core/activitytypes.dataservice";
import { MatDialog } from "@angular/material/dialog";
import { DetailsBase } from "../shared/details.base";

@Component({
    selector: "crew-activitytype",
    template: require('./activitytype.component.html')
})
export class ActivityType extends DetailsBase<Nema.Crew.Model.ActivityType> {
    constructor(
        stateService: StateService,
        dialog: MatDialog,
        @Inject('activityType') activityType: Nema.Crew.Model.ActivityType,
        @Inject(ActivityTypeDataService.Id) activityTypeDataService: ActivityTypeDataService,
        @Inject('$log') $log: ng.ILogService) {

        super(stateService, dialog, activityType, activityTypeDataService, $log);
    }

    public entityName = "Activity";

    public editStateName = "app.settings.activitytypes.edit";

    public listStateName = "app.settings.activitytypes";
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/settings/activitytypes/activitytype.component.ts